export const EXAM_CENTERS = [
  'Chennai (Tamilnadu)',
  'Dimapur (Nagaland)',
  'Guwahati (Assam)',
  'Hyderabad (Telangana)',
  'Jammu (Jammu & Kashmir)',
  'Nagpur (Maharashtra)',
  'Nashik (Maharashtra)',
  'Patna (Bihar)',
  'Pune (Maharashtra)',
  'Vijaywada (Andhra Pradesh)',
  'Warangal (Telangana)',
];
